import Hero from "@/components/Hero";
import PromoBanner from "@/components/PromoBanner";
import BottleMarquee from "@/components/BottleMarquee";
import CategoryTiles from "@/components/CategoryTiles";
import PickupBanner from "@/components/PickupBanner";

export default function Home() {
  return (
    <div className="home-fit app-container w-full flex flex-col min-h-0" data-testid="home-page">
      <Hero />
      <PromoBanner />
      <BottleMarquee />
      <CategoryTiles />
      <PickupBanner />
    </div>
  );
}
